"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreatmentModalityType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var TreatmentModalityType_Factory = /** @class */ (function () {
    function TreatmentModalityType_Factory() {
    }
    TreatmentModalityType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    TreatmentModalityType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    return TreatmentModalityType_Factory;
}());
exports.TreatmentModalityType_Factory = TreatmentModalityType_Factory;
